import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LicenseInfo } from '@mui/x-license';

// Set the license key for MUI X
const licenseKey = process.env.REACT_APP_X_KEY || '';
console.log('License key loaded:', licenseKey ? 'Key found' : 'Key missing');
console.log('License key length:', licenseKey.length);
LicenseInfo.setLicenseKey(licenseKey);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
